import { asset, findAsset } from '@/core/template-engine/asset';

const DEFAULT_MENU_ICON = 'images/menu/hot.png';

// images/menu/<category>.png, falling back to the hot icon.
export function menuIconPath(categoryKey) {
    const own = categoryKey && `images/menu/${categoryKey.toLowerCase()}.png`;
    return own && findAsset(own) ? own : DEFAULT_MENU_ICON;
}

export function menuIcon(categoryKey) {
    return asset(menuIconPath(categoryKey));
}

// Falls back to the site logo when the vendor has no image.
export function vendorImage(vendorCode) {
    return findAsset(`images/vendors/${vendorCode}.png`) || findAsset('images/misc/logo.png');
}

const VENDOR_BANNER_COUNT = 6;

export function vendorBanner(index) {
    const n = ((Number(index) % VENDOR_BANNER_COUNT) + VENDOR_BANNER_COUNT) % VENDOR_BANNER_COUNT;
    return findAsset(`images/vendors/banners/${n + 1}.png`);
}
